import { createContext, useContext, useState, type ReactNode } from 'react'

interface DropdownContextType {
  openDropdown: string | null
  setOpenDropdown: (id: string | null) => void
}

const DropdownContext = createContext<DropdownContextType | undefined>(undefined)

export const DropdownProvider = ({ children }: { children: ReactNode }) => {
  const [openDropdown, setOpenDropdown] = useState<string | null>(null)

  return (
    <DropdownContext.Provider value={{ openDropdown, setOpenDropdown }}>
      {children}
    </DropdownContext.Provider>
  )
}

// eslint-disable-next-line react-refresh/only-export-components
export const useDropdown = () => {
  const context = useContext(DropdownContext)
  if (!context) {
    throw new Error('useDropdown must be used within a DropdownProvider')
  }
  return context
}